import React from 'react';
import { Button, Menu } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import {
    BloqueHorario,
    construirBloquesHorarios,
    TablaDeCursos,
} from 'src/componentes/tablasDeCursos';
import { Contexto } from 'src/contexto';
import Curso from './Curso';

type Props = Readonly<{
    oculto: boolean;
}>;

interface State {
    readonly cargando: boolean;
    readonly bloquesHorarios: readonly BloqueHorario[];
    readonly anchoCompleto: boolean;
}

class HorarioCompleto extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        cargando: true,
        bloquesHorarios: [],
        anchoCompleto: false,
    };

    public componentDidMount() {
        this.obtenerTodosLosCursos().catch(); // La función maneja sus errores
    }

    public render() {
        if (this.props.oculto) return null;

        const { anchoCompleto } = this.state;

        return (
            <>
                <Menu>
                    <Menu.Item>
                        <Button
                            icon={anchoCompleto ? 'compress' : 'expand'}
                            onClick={() => {
                                this.setState(prevState => ({
                                    anchoCompleto: !prevState.anchoCompleto,
                                }));
                            }}
                        />
                    </Menu.Item>
                </Menu>

                <TablaDeCursos
                    cargando={this.state.cargando}
                    bloquesHorarios={this.state.bloquesHorarios}
                    anchoCompleto={this.state.anchoCompleto}
                />
            </>
        );
    }

    private readonly obtenerTodosLosCursos = async () => {
        this.setState({ cargando: true });

        clienteApi
            .ejecutar('listaDeCursos')
            .then(resultados => {
                const { cursos } = resultados;

                this.setState({
                    cargando: false,
                    bloquesHorarios: construirBloquesHorarios(cursos, curso => (
                        <Curso key={curso.id} {...curso} />
                    )),
                });
            })
            .catch(error => {
                this.setState({ cargando: false });
                this.context.mostrarModalError(error);
            });
    };
}

export default HorarioCompleto;



// WEBPACK FOOTER //
// ./src/modulos/Asistencia/paginas/HorarioCompleto/index.tsx